import React, { useState, useEffect } from 'react'
import { v2_siteLocations, v2_roles, v2_designations } from '../../actions/v2/masterData';
import { toast } from 'react-toastify';
import { validateFunctionalForm } from '../../utils';

const Add = (props) => {
    const [state, setState] = useState({
        profilePic: { name: 'profilePic', value: props.data ? props.data.PROFILE_IMAGE : '', isRequired: false, error: '' },
        fullName: { name: 'fullName', value: props.data ? props.data.FULL_NAME : '', isRequired: true, error: '' },
        userName: { name: 'userName', value: props.data ? props.data.USER_NAME : '', isRequired: true, error: '' },
        role: { name: 'role', value: props.data ? props.data.ROLE_ID : '', options: [], isRequired: true, error: '' },
        designation: { name: 'designation', value: props.data ? props.data.DESIGNATION_ID : '', options: [], isRequired: true, error: '' },
        email: { name: 'email', value: props.data ? props.data.EMAIL_ID : '', isRequired: true, error: '' },
        phone: { name: 'phone', value: props.data ? props.data.MOBILE : '', isRequired: true, error: '' },
        password: { name: 'password', value: '', isRequired: props.data ? false : true, error: '' },
        otherDetails: { name: 'otherDetails', value: props.data ? props.data.OTHER_DETAILS : '', isRequired: false, error: '' },
        gender: { name: 'gender', value: props.data ? props.data.GENDER : '', isRequired: true, error: '' }, // Gender field
        siteLocation: { name: 'siteLocation', value: props.data ? props.data.SITE_LOCATION : '', isRequired: true, error: '' }, // Site Location field
    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: prevState[name].isRequired && !value ? 'This field is required' : ''
            }
        }));
    };

    const setOptions = (name, options) => {
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                options: options
            }
        }));
    };

    useEffect(() => {
        v2_roles().then(res => {
            if (res.status) {
                setOptions('role', res.result);
            }
            else {
                toast.error(res.error);
            }
        });
    }, []);

    useEffect(() => {
        if (state.role.value) {
            v2_designations(state.role.value).then(res => {
                if (res.status) {
                    setOptions('designation', res.result);
                }
                else {
                    toast.error(res.error);
                }
            });
        }
        else {
            setState(prevState => ({
                ...prevState,
                ['designation']: {
                    ...prevState['designation'],
                    options: [],
                    value: ''
                }
            }));
        }
    }, [state.role.value]);

    const onSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const formData = new FormData();
            formData.append('fullName', state.fullName.value)
            formData.append('phone', state.phone.value)
            formData.append('password', state.password.value)
            formData.append('email', state.email.value)
            formData.append('otherDetails', state.otherDetails.value)
            formData.append('gender', state.gender.value)
            formData.append('profilePic', state.profilePic.value)


            props.onSubmit(formData);
        }
    };

    const [siteLocations, setSiteLocations] = useState([])

    useEffect(() => {
        v2_siteLocations().then((res) => {
            if (res.status) {
                setSiteLocations(res.result || [])
            }
        })
    }, [])

    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            // Optional: Validate file type (only images)
            if (!file.type.startsWith("image/")) {
                setState((prev) => ({
                    ...prev,
                    profilePic: {
                        ...prev.profilePic,
                        error: "Please upload a valid image file",
                        value: null,
                        preview: null,
                    },
                }));
                return;
            }

            // Create preview URL
            const previewURL = URL.createObjectURL(file);

            // Update state
            setState((prev) => ({
                ...prev,
                profilePic: {
                    ...prev.profilePic,
                    value: file,
                    preview: previewURL,
                    error: "",
                },
            }));
        }
    };


    return (
        <React.Fragment>
            <h4 className="card-title mb-4">{props.title}</h4>
            <div id="basic-example">
                <section>
                    <form onSubmit={onSubmit}>
                        <div className="row">
                            <div className="row">
                                {/* Profile Image */}
                                <div className="col-lg-4 mb-3">
                                    <label className="form-label">Profile Image</label>
                                    <div className="d-flex align-items-center border rounded p-2" style={{ height: '85px' }}>
                                        {/* Preview */}
                                        {
                                            state.profilePic.preview || typeof state.profilePic.value === 'string' ?
                                                (
                                                    <img
                                                        src={
                                                            state.profilePic.preview
                                                                ? state.profilePic.preview
                                                                : props.data.PROFILE_IMAGE_URL
                                                                    ? process.env.REACT_APP_BASE_URL + props.data.PROFILE_IMAGE_URL
                                                                    : '/assets/images/user-logo.png'
                                                        }
                                                        alt="Preview"
                                                        style={{
                                                            width: '65px',
                                                            height: '65px',
                                                            objectFit: 'cover',
                                                            borderRadius: '8px',
                                                            border: '1px solid #ccc',
                                                        }}
                                                    />
                                                ) : (
                                                    <img
                                                        src={
                                                            '/assets/images/user-logo.png'
                                                        }
                                                        alt="Preview"
                                                        style={{
                                                            width: '65px',
                                                            height: '65px',
                                                            objectFit: 'cover',
                                                            borderRadius: '8px',
                                                            border: '1px solid #ccc',
                                                        }}
                                                    />
                                                )}

                                        <div className="mx-3" />

                                        <div className="flex-grow-1">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                className={`form-control ${state.profilePic.error ? 'is-invalid' : ''}`}
                                                name={state.profilePic.name}
                                                onChange={handleImageChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4">
                                    <div className="mb-3">
                                        <label htmlFor="basicpill-firstname-input">
                                            Full name {state.fullName.isRequired  &&<span className='text-danger'>*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className={state.fullName.error && !state.fullName.value ? "form-control is-invalid" : "form-control"}
                                            id="basicpill-firstname-input"
                                            placeholder="Enter Full Name"
                                            name={state.fullName.name}
                                            value={state.fullName.value}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="mb-3">
                                        <label htmlFor="basicpill-lastname-input">
                                            User name {state.userName.isRequired  &&<span className='text-danger'>*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className={state.userName.error && !state.userName.value ? "form-control is-invalid" : "form-control"}
                                            id="basicpill-lastname-input"
                                            disabled
                                            placeholder="Enter User Name"
                                            name={state.userName.name}
                                            value={state.userName.value}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </div>




                        </div>
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-phoneno-input">
                                        Phone {state.phone.isRequired  &&<span className='text-danger'>*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className={state.phone.error && !state.phone.value ? "form-control is-invalid" : "form-control"}
                                        id="basicpill-phoneno-input"
                                        placeholder="Enter Phone No."
                                        name={state.phone.name}
                                        value={state.phone.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-phoneno-input">Role <span className='text-danger'>*</span></label>
                                    <select
                                        className={state.role.error && !state.role.value ? "form-select is-invalid" : "form-select"}
                                        name={state.role.name}
                                        value={state.role.value}
                                        onChange={onChange}
                                        disabled

                                    >
                                        <option value=''>Select Role</option>
                                        {state.role.options.map((item) => {
                                            return (
                                                <option value={item.ROLE_ID} key={item.ROLE_ID}>{item.ROLE_NAME}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-phoneno-input">Designation <span className='text-danger'>*</span></label>
                                    <select
                                        className={state.designation.error && !state.designation.value ? "form-select is-invalid" : "form-select"}
                                        name={state.designation.name}
                                        value={state.designation.value}
                                        disabled

                                        onChange={onChange}
                                    >
                                        <option value=''>Select Role</option>
                                        {state.designation.options.map((item) => {
                                            return (
                                                <option value={item.DESIGNATION_ID} key={item.DESIGNATION_ID}>{item.DESIGNATION_NAME}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-3" style={{ background: "#fffafa" }}>
                                <div className="mb-3">
                                    <label htmlFor="basicpill-email-input">Email {state.email.isRequired  &&<span className='text-danger'>*</span>}</label>
                                    <input
                                        type="email"
                                        className={state.email.error && !state.email.value ? "form-control is-invalid" : "form-control"}
                                        id="basicpill-email-input"
                                        placeholder="Enter Email ID"
                                        name={state.email.name}
                                        value={state.email.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-lg-3" style={{ background: "#fffafa" }}>
                                <div className="mb-3">
                                    <label htmlFor="basicpill-password-input">
                                        Password {state.password.isRequired && <span className='text-danger'>*</span>}
                                    </label>
                                    <input
                                        type="password"
                                        className={state.password.error && !state.password.value ? "form-control is-invalid" : "form-control"}
                                        id="basicpill-password-input"
                                        placeholder=""
                                        name={state.password.name}
                                        value={state.password.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="mb-3">
                                    <label htmlFor="gender-input">Gender {state.gender.isRequired  &&<span className='text-danger'>*</span>}</label>
                                    <select
                                        className={state.gender.error && !state.gender.value ? "form-select is-invalid" : "form-select"}
                                        name={state.gender.name}
                                        value={state.gender.value}
                                        onChange={onChange}
                                    >
                                        <option value="">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="mb-3">
                                    <label htmlFor="siteLocation-input">Site Location <span className='text-danger'>*</span></label>
                                    <select
                                        name={state.siteLocation.name}
                                        value={state.siteLocation.value}
                                        disabled
                                        onChange={onChange}
                                        className={`form-select ${state.siteLocation.error ? 'is-invalid' : ''}`}
                                    >
                                        <option value="">Select Site Location</option>
                                        {siteLocations?.map((type) => (
                                            <option key={type.ID} value={type.ID}>
                                                {type.LOCATION_NAME}
                                            </option>
                                        ))}
                                    </select>
                                    {state.siteLocation.error && (
                                        <div className="invalid-feedback">{state.siteLocation.error}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <button
                                        type="submit"
                                        className="btn btn-success waves-effect btn-label waves-light me-2"
                                    >
                                        <i className="bx bx-check-double label-icon" /> {props.buttonName}
                                    </button>
                                    <button
                                        type="reset"
                                        className="btn btn-danger waves-effect btn-label waves-light"
                                        onClick={() => window.history.back()}
                                    >
                                        <i className="bx bx-block label-icon" /> Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </React.Fragment>
    );
};

export default Add;
